// eslint-disable-next-line
import { UserLayout, BasicLayout, BlankLayout } from '@/layouts'
import { bxAnaalyse } from '@/core/icons'
import interactiveLive from './interactiveLive'
import goodsManage from './goodsManage'
import smartPic from './smartPic'
import userManage from './userManage'
import knowledgeMange from './knowledgeMange'
import smartPlay from './smartPlay'

const RouteView = {
  name: 'RouteView',
  render: (h) => h('router-view'),
}

//静态 login/404 -parent
/*

{
  path:'/home',
  children:[{接口返回的}] // /home/SmartTools
}
*/

export const asyncRouterMap = [
  // AI智能工具（首页）
  {
    path: '/',
    component: BasicLayout,
    meta: { title: 'menu.home' },
    redirect: '/smartTools/SmartTools', //'/smartTools/SmartTools',
    children: [
      {
        path: '/SmartTools',
        name: 'smartTool',
        redirect: '/smartTools/SmartTools',
        component: RouteView,
        hideChildrenInMenu: true,
        meta: { title: 'menu.smartTools', keepAlive: true, icon: 'home', permission: ['dashboard'] },
        children: [
          {
            path: '/smartTools/SmartTools',
            name: 'smartTools',
            component: () => import('@/views/smartTools/SmartTools'),
            meta: { title: 'menu.smartTools', keepAlive: false, permission: ['dashboard'] },
          },
        ],
      },
      // 数字人列表
      {
        path: '/digitalPersonList',
        name: 'DigitalPersonList',
        component: () => import('@/views/digitalPersonList/index.vue'),
        meta: { title: '数字人列表', icon: 'camera', permission: ['table'] },
      },
      // AI智播
      {
        path: '/LiveList',
        name: 'smartPlay',
        component: RouteView,
        hideChildrenInMenu: true,
        redirect: '/smartPlay/LiveList',
        meta: { title: 'menu.smartPlay', icon: 'table', permission: ['table'] },
        children: smartPlay,
      },
      //互动视频直播
      {
        path: '/InteractiveLiveList',
        name: 'interactiveLive',
        component: RouteView,
        hideChildrenInMenu: true,
        redirect: '/interactiveLive/InteractiveLiveList',
        meta: { title: 'menu.interactiveLive', icon: 'youtube', permission: ['table'] },
        children: interactiveLive,
      },
      // 商品库
      {
        path: '/GoodsList',
        component: RouteView,
        name: 'goodsManage',
        hideChildrenInMenu: true,
        redirect: '/goodsManage/GoodsList',
        meta: { title: 'menu.goodsManage', icon: 'shop', permission: ['table'] },
        children: goodsManage,
      },
      // AI智图
      {
        path: '/PicList',
        redirect: '/smartPic/PicList',
        component: RouteView,
        name: 'smartPic',
        // hidden: true,
        hideChildrenInMenu: true,
        meta: { title: 'AI模特', icon: 'skin', permission: ['table'] },
        children: smartPic,
      },
      //互动库
      {
        path: '/interactiveLibrary',
        name: 'interactiveLibraryIndex',
        hidden: true,
        component: () => import('@/views/interactiveLibrary/index'),
        meta: { title: 'menu.interactiveLibrary', icon: 'interaction', keepAlive: true, permission: ['table'] },
      },
      //消息中心
      {
        path: '/messageCenter',
        name: 'messageCenterIndex',
        hidden: true,
        component: () => import('@/views/messageCenter/index.vue'),
        meta: { title: 'menu.messageCenter', icon: 'message', keepAlive: true, permission: ['table'] },
      },
      //个人中心
      {
        path: '/personalCenter',
        name: 'personalCenterIndex',
        hidden: true,
        component: () => import('@/views/personalCenter/index.vue'),
        meta: { title: 'menu.personalCenter', icon: 'user', keepAlive: true, permission: ['table'] },
      },
      //数据看板
      {
        path: '/dataBoard',
        name: 'dataBoardIndex',
        component: () => import('@/views/dataBoard/index.vue'),
        meta: { title: 'menu.dataBoard', icon: 'line-chart', keepAlive: true, permission: ['table'] },
      },
      // 知识库
      {
        path: '/KnowledgeList',
        component: RouteView,
        redirect: '/knowledgeMange/KnowledgeList',
        name: 'knowledgeMange',
        hide: true,
        hideChildrenInMenu: true,
        meta: { title: 'menu.knowledgeManage', icon: 'read', permission: ['table'] },
        children: knowledgeMange,
      },
      // 用户管理
      {
        path: '/UserList',
        component: RouteView,
        redirect: '/userManage/UserList',
        name: 'userManage',
        hideChildrenInMenu: true,
        meta: { title: 'menu.userManage', icon: 'usergroup-add', permission: ['table'] },
        children: userManage,
      },
    ],
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
]

/**
 * 基础路由--无需控制权限的路由或者需要在未登录情况访问的路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/index'),
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register'),
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/RegisterResult'),
      },
      {
        path: 'find-password',
        name: 'findPassword',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/findPassword.vue'),
      },
      {
        path: 'recover',
        name: 'recover',
        component: undefined,
      },
    ],
  },

  // 数智人课堂
  {
    path: '/digitalIntelligentHumanClassroom',
    redirect: '/digitalIntelligentHumanClassroom/index',
    component: RouteView,
    hidden: true,
    children: [
      {
        path: '/digitalIntelligentHumanClassroom/index',
        name: 'digitalIntelligentHumanClassroomIndex',
        component: () => import('@/views/digitalIntelligentHumanClassroom/index.vue'),
      },
    ],
  },
  // 帮助中心
  {
    path: '/documentView',
    redirect: '/documentView/HelpCenter',
    component: BasicLayout,
    hidden: true,
    children: [
      {
        path: '/documentView/helpCenter',
        name: 'helpCenter',
        component: () => import('@/views/documentView/HelpCenter'),
      },
    ],
  },
  {
    path: '/404',
    component: () => import('@/views/exception/404'),
  },

  // {
  //   path: '/',
  //   name: 'index',
  //   component: BasicLayout,
  //   meta: { title: 'menu.home' },
  //   redirect: '/smartTools/SmartTools', //'/smartTools/SmartTools',
  //   children: [
  //     {
  //       path: '/SmartTools',
  //       name: 'SmartTool',
  //       redirect: '/smartTools/SmartTools',
  //       component: RouteView,
  //       hideChildrenInMenu: true,
  //       meta: { title: 'menu.smartTools', keepAlive: true, icon: bxAnaalyse, permission: ['dashboard'] },
  //       children: [
  //         {
  //           path: '/smartTools/SmartTools',
  //           name: 'SmartTools',
  //           component: () => import('@/views/smartTools/SmartTools'),
  //           meta: { title: 'menu.smartTools', keepAlive: false, permission: ['dashboard'] },
  //         },
  //       ],
  //     },
  //   ],
  // },
  // 创建品牌
  // {
  //   path: '*',
  //   name: 'CreateBrand',
  //   component: BasicLayout,
  //   meta: { title: 'menu.brandMessage' },
  //   redirect: '/createBrand/createBrandIndex',
  //   hidden: true,
  //   children: [
  //     {
  //       path: '/createBrand/createBrandIndex',
  //       name: 'CreateBrands',
  //       component: () => import('@/views/createBrand/index.vue'),
  //       meta: { title: 'menu.createBrand', keepAlive: false, permission: ['dashboard'] },
  //     },
  //   ],
  // },
]
